import EventBase from './EventBase'
import EventID from './EventID'
/**
 * 200	条件分歧
 */

export enum IFType {
    /// <summary>
    /// 数值索引
    /// </summary>
    VarIndex = 0,
    /// <summary>
    /// 鲜花
    /// </summary>
    Flower = 1,
    /// <summary>
    /// 二周目变量
    /// </summary>
    VarEx = 2,
    /// <summary>
    /// 鼠标按下/经过
    /// </summary>
    Mouse = 3,
    /// <summary>
    /// 平台
    /// </summary>
    Platform = 4,
    /// <summary>
    /// 支付
    /// </summary>
    Pay = 6,
    /// <summary>
    /// 任务
    /// </summary>
    Task = 5,
    /// <summary>
    /// 剧情锁
    /// </summary>
    Mall = 7,
    /// <summary>
    /// 限时商品锁
    /// </summary>
    LimiteMall = 8,
}

export default class EventIF extends EventBase {
  constructor() {
    super()
    this.Parameter = ['0', '0', '0', '0', '0', '0']
  }


  /// <summary>
  /// 事件ID
  /// </summary>
  Code = EventID.IF

  static IfType = IFType

  // #region 数据绑定的都在这儿
  /// <summary>
  /// 当前的类型Type
  /// </summary>
  get Type() {
    let type: IFType = IFType.VarIndex
    if (this.Parameter?.length === 7  && this.Parameter[6].startsWith('TA')) {
      return IFType.Task
    }
    if (!isNaN(parseInt(this.Parameter![0]))) {
      return IFType.VarIndex
    } else {
      switch (this.Parameter?.[0]?.substring(0, 2)) {
        case 'EX':
          type = IFType.VarEx
          break
        case 'FL':
          type = IFType.Flower
          break
        case 'MO':
          type = IFType.Mouse
          break
        case 'PT':
          type = IFType.Platform
          break
        case 'PA':
          type = IFType.Pay
          break
        case 'ST':
          type = IFType.Mall
          break
        case 'LT':
          type = IFType.LimiteMall
          break
      }
    }
    return type
  }

  /// <summary>
  /// 是否存在else
  /// </summary>
  get IsHaveElse() {
    return parseInt(this.Parameter![4]) === 1
  }
  set IsHaveElse(value) {
    this.Parameter![4] = value ? '1' : '0'
  }

  /// <summary>
  /// 显示信息
  /// </summary>
  get Description() {
    return this.Parameter?.[5] || ''
  }
  set Description(value) {
    this.Parameter![5] = value
  }

  /// <summary>
  /// 返回以，隔开的Parameter字符串
  /// </summary>
  /// <returns></returns>
  public GetParameterStr() {
    return this.Parameter?.join(',')
  }

  public showIndexNum!: string
  /// <summary>
  /// 显示的序号，无实际意义
  /// </summary>
  get ShowIndex() {
    return this.showIndexNum
  }
  set ShowIndex(value) {
    this.showIndexNum = value
  }

  /// <summary>
  /// 获取显示信息
  /// </summary>
  /// <returns></returns>
  // #endregion
}

/// <summary>
/// 数值索引类
/// </summary>
export class VarClass extends EventIF {
  public constructor() {
    super()
    this.Parameter = ['0', '0', '0', '0', '0', '']
  }
  /// <summary>
  /// 数值索引
  /// </summary>
  get VarIndex() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set VarIndex(value) {
    this.Parameter![0] = value.toString()
  }

  /// <summary>
  /// 关系索引
  /// </summary>
  get RelationIndex() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set RelationIndex(value) {
    this.Parameter![1] = value.toString()
  }

  /// <summary>
  /// 比较对象类型
  /// </summary>
  get CmpObject() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set CmpObject(value) {
    this.Parameter![2] = value.toString()
  }
  /// <summary>
  /// 操作数
  /// </summary>
  get OperatNumber() {
    return this.Parameter?.[3] || ''
  }
  set OperatNumber(value) {
    // this.SetProperty(this.Parameter, '3', value, "OperatNumber");
    this.Parameter[3] = value
  }
}
/// <summary>
/// 二周目类
/// </summary>
export class VarExClass extends EventIF {
  constructor() {
    super()
    this.Parameter = ['EX|0', '0', '0', '0', '0', '']
  }
  /// <summary>
  /// 数值索引
  /// </summary>
  get VarIndex() {
    return parseInt(this.Parameter?.[0]?.split('|')[1] || '')
  }
  set VarIndex(value) {
    this._VarIndexStr = 'EX|' + value.toString()
    this.Parameter![0] = 'EX|' + value.toString()
  }

  public _VarIndexStr = ''
  /// <summary>
  /// 数值索引字符串
  /// </summary>
  get VarIndexStr() {
    return this._VarIndexStr
  }

  /// <summary>
  /// 关系索引
  /// </summary>
  get RelationIndex() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set RelationIndex(value) {
    this.Parameter![1] = value.toString()
  }

  /// <summary>
  /// 比较对象类型
  /// </summary>
  get CmpObject() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set CmpObject(value) {
    this.Parameter![2] = value.toString()
  }

  /// <summary>
  /// 操作数
  /// </summary>
  get OperatNumber() {
    return this.Parameter?.[3] || ''
  }
  set OperatNumber(value) {
    this.Parameter![3] = value
  }
}
/// <summary>
/// 鲜花类
/// </summary>
export class FlowerClass extends EventIF {
  constructor() {
    super()
    this.Parameter = ['FL|', '0', '0', '0', '0', '']
  }
  /// <summary>
  /// 数值索引
  /// </summary>
  get VarIndex() {
    return 'FL|'
  }

  /// <summary>
  /// 关系索引
  /// </summary>
  get RelationIndex() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set RelationIndex(value) {
    this.Parameter![1] = value.toString()
  }

  /// <summary>
  /// 比较对象类型
  /// </summary>
  get CmpObject() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set CmpObject(value) {
    this.Parameter![2] = value.toString()
  }

  /// <summary>
  /// 操作数
  /// </summary>
  get OperatNumber() {
    return this.Parameter?.[3] || ''
  }
  set OperatNumber(value) {
    this.Parameter![3] = value
  }

  // 操作数丸子
  get OperatNumberPakors() {
    this.InitOperatNumberPakorasZero()
    return this.Parameter[6]
  }

  set OperatNumberPakors(val) {
    this.Parameter[6] = val
  }


  // 升级条件分歧数据，支持丸子锁
  InitOperatNumberPakorasZero() {
			if (this.Parameter.length < 7 || !(this.Parameter[6])) {
				if (this.CmpObject === 0 || this.CmpObject === 1 || this.CmpObject === 2) {
					this.Parameter[6] = "0";
				}
				else if (this.CmpObject === 3 || this.CmpObject === 4) {
					this.Parameter[6] = this.Parameter[3];
					let msgItem: string[] = [];
					if (this.Parameter[3] != null) {
						msgItem = this.Parameter[3].split(',');
						for (let i = 0; i < msgItem.length; i++) {
							const _data = msgItem[i].split('|');
							if (_data == null || _data.length < 2) continue;
							switch (_data[0]) {
								case "n":
								case "v":
								case "x":
								case "s":
								default:
									_data[1] = "0";
									msgItem[i] = _data.join("|");
									break;
							}
						}
						this.Parameter[6] = msgItem.join(",");
					}
				}
			}
		}

  Init(para: string[]) {
    this.Parameter =
        para.length < 7 ? ['FL|', '0', '0', '0', '0', ''] : ['FL|', '0', '0', '0', '0', '', '0']
        if ((para[1])){
          this.RelationIndex = parseInt(para[1])
        }
        if ((para[2])) {
          this.CmpObject = parseInt(para[2])
        }
        this.OperatNumber = para[3]
        this.IsHaveElse = para[4] == '1'
        this.Description = para[5]
        if (para.length > 6) {
          this.OperatNumberPakors = para[6]
        }
  }
}
/// <summary>
/// 鼠标按下类
/// </summary>
export class MouseClass extends EventIF {
  /// <summary>
  /// 矩形信息
  /// </summary>
  get RectInfo(): any {
    if (this.RectType == 0)
      return (this.RectInfo = new RectSize(this.PicID.split(',')))
    else return new RectSize(['0', '0', '100', '100'])
  }
  set RectInfo(value) {}

  public constructor() {
    super()
    this.Parameter = ['MO|', '0', '0,0,100,100', '0', '0', '']
  }
  /// <summary>
  /// 数值索引字符串
  /// </summary>
  get VarIndex() {
    return 'MO|'
  }

  // #region 绑定的都在这里
  /// <summary>
  /// 矩形类型
  /// </summary>
  get RectType() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set RectType(value) {
    this.Parameter![1] = value.toString()
    if (this.RectType == 0) {
      if (this.PicID.split(',').length != 4) {
        this.PicID = '0,0,100,100'
      }
    } else {
      if (this.PicID.split(',').length == 4) {
        this.PicID = this.PicID.split(',')[0]
      }
    }
  }

  /// <summary>
  /// 图片编号
  /// </summary>
  get PicID() {
    return this.Parameter?.[2] || ''
  }
  set PicID(value) {
    this.Parameter![2] = value.toString()
  }

  /// <summary>
  /// 是否按下(是经过还是按下)
  /// </summary>
  get IsPressedDown() {
    return parseInt(this.Parameter?.[3] ?? '') == 1 ? true : false
  }
  set IsPressedDown(value) {
    this.Parameter![3] = value ? '1' : '0'
  }
}

class RectSize {
  arr: string[]
  constructor(arr: string[]) {
    this.arr = arr
  }

  get X() {
    return parseInt(this.arr[0])
  }

  set X(val) {
    this.arr[0] = val.toString()
  }

  get Y() {
    return parseInt(this.arr[1])
  }
  
  set Y(val) {
    this.arr[1] = val.toString()
  }

  get Width() {
    return  parseInt(this.arr[2])
  }

  set Width(val) {
    this.arr[2] = val.toString()
  }

  get Height() {
    return parseInt(this.arr[3])
  }

  set Height(val) {
    this.arr[3] = val.toString()
  }
}

/// <summary>
/// 平台类
/// </summary>
export class PlateFormClass extends EventIF {
  constructor() {
    super()
    this.Parameter = ['PT|', '0', '0', '0', '0', '']
  }
  get VarIndex() {
    return 'PT|'
  }

  /// <summary>
  /// 平台类型(1pc,2web,3Android,4IOS,5H5)
  /// </summary>
  get PlateType() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set PlateType(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }
}
/// <summary>
/// 支付类
/// </summary>
export class PayClass extends EventIF {
  constructor() {
    super()
    this.Parameter = ['PA|0', '0', '0', '0', '0', '']
  }
  /// <summary>
  /// 二周目变量
  /// </summary>
  get VarExIndex() {
    if (
      'PA|0' == this.Parameter?.[0] ||
      (this.Parameter?.[0] && this.Parameter[0].split('|').length < 3)
    ) {
      return -1
    }
    return parseInt(this.Parameter?.[0].split('|')[2] || '')
  }
  set VarExIndex(value) {
    this.Parameter![0] = 'PA|EX|' + value.toString()
  }

  /// <summary>
  /// 是否恢复否买
  /// </summary>
  get IsResuption() {
    return parseInt(this.Parameter?.[1] ?? '') == 1 ? true : false
  }
  set IsResuption(value) {
    this.Parameter![1] = value ? '1' : '0'
  }

  /// <summary>
  /// 商品名称（ID）
  /// </summary>
  get PurchasID() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set PurchasID(value) {
    this.Parameter![2] = value.toString()
  }
}
/// <summary>
/// 任务类
/// </summary>
export class TaskClass extends EventIF {
  constructor() {
    super()
    this.Parameter = ['0', '6', '0', '0', '0', '', 'TA|1']
  }
  get TaskID() {
    return parseInt(this.Parameter?.[6].split('|')[1] || '')
  }
  set TaskID(value) {
    this.Parameter![6] = 'TA|' + value.toString()
  }
}

/// <summary>
/// 平台类
/// </summary>
export class MallClass extends EventIF {
  constructor() {
    super()
    this.Parameter = ['ST|', '0', '0', '0', '0', '']
  }
  get VarIndex() {
    return 'ST|'
  }

  /// <summary>
  /// 商品名称（ID）
  /// </summary>
  get GoodsID() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set GoodsID(value) {
    this.Parameter[2] = value.toString()
  }
}

export class LimitMallClass extends EventIF {
  constructor() {
    super()
    this.Parameter = ['LT|', '0', '0', '0', '0', '']
  }
  get VarIndex() {
    return 'LT|'
  }

  /// <summary>
  /// 商品名称（ID）
  /// </summary>
  get GoodsID() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set GoodsID(value) {
    this.Parameter[2] = value.toString()
  }
}

/// <summary>
/// 平台类型(1pc,2web,3Android,4IOS,5H5)
/// </summary>
export enum PlateType {
  PC = 1,
  WEB = 2,
  ANDROID = 3,
  IOS = 4,
  H5 = 5,
}

/// <summary>
/// 比较对象类型
/// </summary>
export enum CmpObjectType {
  /// <summary>
  /// 常量
  /// </summary>
  Constant = 0,
  /// <summary>
  /// 其他数值
  /// </summary>
  Other = 1,
  /// <summary>
  /// 二周目数值
  /// </summary>
  VarEx = 2,
}
